module.exports = __webpack_public_path__ + "img/Wp_2027.db0b1fdd.png";